export const testData = [
	{
		id: "RR-36129",
		style_name: "HOLLAND",
		season: "AW-24",
		brand: "RARE RABBIT",
		division: "APPARELS",
		sub_brand: "RR",
		category: "SHIRT",
		sub_category: "REVERSIBLE",
		status: "PUBLISHED",
		stage: "FOB_PO",
		size_type: "S-XL",
		size_type_updated_by: "adarsh.h@thehouseofrare.com",
		mrp: 3999,
		mrp_updated_by: "adarsh.h@thehouseofrare.com",
		is_published: true,
		rejected: false,
		published_by: "adarsh.h@thehouseofrare.com",
		created_by: "adarsh.h@thehouseofrare.com",
		published_date: "2024-09-11T00:00:00.000Z",
		fabric_published_by: "adarsh.h@thehouseofrare.com",
		createdAt: "2024-09-11T08:23:40.000Z",
		updatedAt: "2024-09-12T06:55:22.000Z",
		styleProduction: [
			{
				id: 4,
				production_type: "FOB",
				buying_qty: 277,
				approved: true,
				approved_by: "adarsh.h@thehouseofrare.com",
				approved_date: "12/09/2024",
				createdAt: "2024-09-12T06:55:24.000Z",
				updatedAt: "2024-09-12T06:55:24.000Z",
				style_id: "RR-36129",
			},
		],
		styleColorBuying: [
			{
				id: 27366,
				total_qty: 181,
				published_by: "adarsh.h@thehouseofrare.com",
				is_published: true,
				approved_date: "2024-11-08T18:30:00.000Z",
				stage: "SOURCING",
				createdAt: "2024-09-11T08:27:53.000Z",
				updatedAt: "2024-09-11T09:42:51.000Z",
				style_id: "RR-36129",
				color_id: 40169,
				colorBuyingQty: [
					{
						id: 7,
						channel: "EBO",
						total_qty: 24,
						s1: 12,
						s2: 12,
						s3: 0,
						s4: 0,
						s5: 0,
						s6: 0,
						s7: 0,
						s8: 0,
						s9: 0,
						s10: 0,
						s11: 0,
						s12: 0,
						s13: 0,
						s14: 0,
						s15: 0,
						s16: 0,
						s17: 0,
						s18: 0,
						s19: 0,
						s20: 0,
						s21: 0,
						s22: 0,
						s23: 0,
						s24: 0,
						s25: 0,
						s26: 0,
						s27: 0,
						s28: 0,
						s29: 0,
						s30: 0,
						warehouse: "GGN",
						createdAt: "2024-09-11T08:35:10.000Z",
						updatedAt: "2024-09-11T09:42:52.000Z",
						color_buying_id: 27366,
					},
				],
			},
			{
				id: 27367,
				total_qty: 181,
				published_by: "adarsh.h@thehouseofrare.com",
				is_published: true,
				approved_date: "2024-11-08T18:30:00.000Z",
				stage: "SOURCING",
				createdAt: "2024-09-11T08:27:53.000Z",
				updatedAt: "2024-09-11T09:42:51.000Z",
				style_id: "RR-36129",
				color_id: 40169,
				colorBuyingQty: [
					{
						id: 7,
						channel: "EBO",
						total_qty: 24,
						s1: 12,
						s2: 12,
						s3: 0,
						s4: 0,
						s5: 0,
						s6: 0,
						s7: 0,
						s8: 0,
						s9: 0,
						s10: 0,
						s11: 0,
						s12: 0,
						s13: 0,
						s14: 0,
						s15: 0,
						s16: 0,
						s17: 0,
						s18: 0,
						s19: 0,
						s20: 0,
						s21: 0,
						s22: 0,
						s23: 0,
						s24: 0,
						s25: 0,
						s26: 0,
						s27: 0,
						s28: 0,
						s29: 0,
						s30: 0,
						warehouse: "GGN",
						createdAt: "2024-09-11T08:35:10.000Z",
						updatedAt: "2024-09-11T09:42:52.000Z",
						color_buying_id: 27366,
					},
				],
			},
			{
				id: 27387,
				total_qty: 181,
				published_by: "adarsh.h@thehouseofrare.com",
				is_published: true,
				approved_date: "2024-11-08T18:30:00.000Z",
				stage: "SOURCING",
				createdAt: "2024-09-11T08:27:53.000Z",
				updatedAt: "2024-09-11T09:42:51.000Z",
				style_id: "RR-36129",
				color_id: 40169,
				colorBuyingQty: [
					{
						id: 7,
						channel: "EBO",
						total_qty: 24,
						s1: 12,
						s2: 12,
						s3: 0,
						s4: 0,
						s5: 0,
						s6: 0,
						s7: 0,
						s8: 0,
						s9: 0,
						s10: 0,
						s11: 0,
						s12: 0,
						s13: 0,
						s14: 0,
						s15: 0,
						s16: 0,
						s17: 0,
						s18: 0,
						s19: 0,
						s20: 0,
						s21: 0,
						s22: 0,
						s23: 0,
						s24: 0,
						s25: 0,
						s26: 0,
						s27: 0,
						s28: 0,
						s29: 0,
						s30: 0,
						warehouse: "GGN",
						createdAt: "2024-09-11T08:35:10.000Z",
						updatedAt: "2024-09-11T09:42:52.000Z",
						color_buying_id: 27366,
					},
				],
			},
		],
		styleImages: [
			{
				id: 33015,
				is_main: true,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:42.000Z",
				updatedAt: "2024-09-11T08:23:42.000Z",
				color_id: null,
				style_id: "RR-36129",
			},
			{
				id: 33013,
				is_main: false,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:41.000Z",
				updatedAt: "2024-09-11T08:23:41.000Z",
				color_id: 40169,
				style_id: "RR-36129",
			},
			{
				id: 33014,
				is_main: false,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:41.000Z",
				updatedAt: "2024-09-11T08:23:41.000Z",
				color_id: 40170,
				style_id: "RR-36129",
			},
		],
		styleSizeType: {
			id: 32,
			size_type: "S-XL",
			s1: "S",
			s2: "M",
			s3: null,
			s4: null,
			s5: null,
			s6: null,
			s7: null,
			s8: null,
			s9: null,
			s10: null,
			s11: null,
			s12: null,
			s13: null,
			s14: null,
			s15: null,
			s16: null,
			s17: null,
			s18: null,
			s19: null,
			s20: null,
			s21: null,
			s22: null,
			s23: null,
			s24: null,
			s25: null,
			s26: null,
			s27: null,
			s28: null,
			s29: null,
			s30: null,
			user_created: "MATHEW",
			user_last_modified: "MATHEW",
			count: "2",
			createdAt: "2024-08-29T07:28:53.000Z",
			updatedAt: "2024-08-29T07:28:53.000Z",
		},
	},
	{
		id: "RR-36130",
		style_name: "DOMA",
		season: "AW-24",
		brand: "RARE RABBIT",
		division: "APPARELS",
		sub_brand: "RR",
		category: "BELT",
		sub_category: "REVERSIBLE",
		status: "PUBLISHED",
		stage: "FOB_PO",
		size_type: "S-XL",
		size_type_updated_by: "adarsh.h@thehouseofrare.com",
		mrp: 3999,
		mrp_updated_by: "adarsh.h@thehouseofrare.com",
		is_published: true,
		rejected: false,
		published_by: "adarsh.h@thehouseofrare.com",
		created_by: "adarsh.h@thehouseofrare.com",
		published_date: "2024-09-11T00:00:00.000Z",
		fabric_published_by: "adarsh.h@thehouseofrare.com",
		createdAt: "2024-09-11T08:23:40.000Z",
		updatedAt: "2024-09-12T06:55:22.000Z",
		styleProduction: [
			{
				id: 4,
				production_type: "FOB",
				buying_qty: 277,
				approved: true,
				approved_by: "adarsh.h@thehouseofrare.com",
				approved_date: "12/09/2024",
				createdAt: "2024-09-12T06:55:24.000Z",
				updatedAt: "2024-09-12T06:55:24.000Z",
				style_id: "RR-36129",
			},
		],
		styleColorBuying: [
			{
				id: 27366,
				total_qty: 181,
				published_by: "adarsh.h@thehouseofrare.com",
				is_published: true,
				approved_date: "2024-11-08T18:30:00.000Z",
				stage: "SOURCING",
				createdAt: "2024-09-11T08:27:53.000Z",
				updatedAt: "2024-09-11T09:42:51.000Z",
				style_id: "RR-36129",
				color_id: 40169,
				colorBuyingQty: [
					{
						id: 7,
						channel: "EBO",
						total_qty: 24,
						s1: 12,
						s2: 12,
						s3: 0,
						s4: 0,
						s5: 0,
						s6: 0,
						s7: 0,
						s8: 0,
						s9: 0,
						s10: 0,
						s11: 0,
						s12: 0,
						s13: 0,
						s14: 0,
						s15: 0,
						s16: 0,
						s17: 0,
						s18: 0,
						s19: 0,
						s20: 0,
						s21: 0,
						s22: 0,
						s23: 0,
						s24: 0,
						s25: 0,
						s26: 0,
						s27: 0,
						s28: 0,
						s29: 0,
						s30: 0,
						warehouse: "GGN",
						createdAt: "2024-09-11T08:35:10.000Z",
						updatedAt: "2024-09-11T09:42:52.000Z",
						color_buying_id: 27366,
					},
				],
			},
		],
		styleImages: [
			{
				id: 33015,
				is_main: true,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:42.000Z",
				updatedAt: "2024-09-11T08:23:42.000Z",
				color_id: null,
				style_id: "RR-36129",
			},
			{
				id: 33013,
				is_main: false,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:41.000Z",
				updatedAt: "2024-09-11T08:23:41.000Z",
				color_id: 40169,
				style_id: "RR-36129",
			},
			{
				id: 33014,
				is_main: false,
				url: "https://storage.googleapis.com/rarebox_files/PimImages/Screenshot 2024-09-11 132338.png",
				createdAt: "2024-09-11T08:23:41.000Z",
				updatedAt: "2024-09-11T08:23:41.000Z",
				color_id: 40170,
				style_id: "RR-36129",
			},
		],
		styleSizeType: {
			id: 32,
			size_type: "S-XL",
			s1: "S",
			s2: "M",
			s3: null,
			s4: null,
			s5: null,
			s6: null,
			s7: null,
			s8: null,
			s9: null,
			s10: null,
			s11: null,
			s12: null,
			s13: null,
			s14: null,
			s15: null,
			s16: null,
			s17: null,
			s18: null,
			s19: null,
			s20: null,
			s21: null,
			s22: null,
			s23: null,
			s24: null,
			s25: null,
			s26: null,
			s27: null,
			s28: null,
			s29: null,
			s30: null,
			user_created: "MATHEW",
			user_last_modified: "MATHEW",
			count: "2",
			createdAt: "2024-08-29T07:28:53.000Z",
			updatedAt: "2024-08-29T07:28:53.000Z",
		},
	},
];

export const fobGeneralFields = {
	owner_site: { name: "Owner Site", key: "owner_site", inputType: "input", required: true },
	channel: { name: "Channel", key: "channel", inputType: "input", required: true },
	date: { name: "Date", key: "date", inputType: "date", required: true },
	order_no: { name: "Order No", key: "order_no", inputType: "input", required: true },
	document_no: { name: "Document No", key: "document_no", inputType: "input", required: false },
	purchase_type: { name: "Purchase Type", key: "purchase_type", inputType: "dropdown", required: true },
	vendor_name: { name: "Vendor Name", key: "vendor_name", inputType: "dropdown", required: true, apiCol: "company_name" },
	factory: { name: "Factory", key: "factory", inputType: "dropdown", required: true, apiCol: "name" },
	currency: { name: "Currency", key: "currency", inputType: "input", required: true },
	trade_group: { name: "Trade Group", key: "trade_group", inputType: "input", required: false },
	term: { name: "Term", key: "term", inputType: "input", required: false },
	valid_from: { name: "Valid From", key: "valid_from", inputType: "date", required: true },
	valid_till: { name: "Valid Till", key: "valid_till", inputType: "date", required: true },
	exchange_rate: { name: "Exchange Rate", key: "exchange_rate", inputType: "input", required: false },
	agent: { name: "Agent", key: "agent", inputType: "input", required: false },
	commission_rate: { name: "Commission Rate", key: "commission_rate", inputType: "input", required: false },
	transporter: { name: "Transporter", key: "transporter", inputType: "input", required: false },
	merchandiser_name: { name: "Merchandiser Name", key: "merchandiser_name", inputType: "input", required: false },
	status: { name: "Status", key: "status", inputType: "input", required: true },
	delivery_date: { name: "Delivery Date", key: "delivery_date", inputType: "date", required: true },
};
